import {
    GET_HOTUSER_LIST_REQUEST,
    GET_HOTUSER_LIST_SUCCESS,
    GET_HOTUSER_LIST_FAILURE,
    ADD_HOTUSER_REQUEST,
    ADD_HOTUSER_REQUEST_SUCCESS,
    ADD_HOTUSER_REQUEST_FAILURE,
    DELETE_HOTUSER_REQUEST,
    DELETE_HOTUSER_REQUEST_SUCCESS,
    DELETE_HOTUSER_REQUEST_FAILURE,
    SYNC_HOTUSER_REQUEST,
    SYNC_HOTUSER_REQUEST_SUCCESS,
    SYNC_HOTUSER_REQUEST_FAILURE,
    GET_USER_LIST_REQUEST,
    GET_USER_LIST_SUCCESS,
    GET_USER_LIST_FAILURE,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    SIGNUP_REQUEST,
    SIGNUP_SUCCESS,
    SIGNUP_FAILURE,
    RESEND_REQUEST,
    RESEND_SUCCESS,
    RESEND_FAILURE,
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE,
} from '../constant/actionTypes';

export const getHotUserList = payload => ({
    type: GET_HOTUSER_LIST_REQUEST,
    payload
});

export const getHotUserListSuccess = payload => ({
    type: GET_HOTUSER_LIST_SUCCESS,
    payload
});

export const getHotUserListFailure = payload => ({
    type: GET_HOTUSER_LIST_FAILURE,
    payload
});

export const addHotUser = payload => ({
    type: ADD_HOTUSER_REQUEST,
    payload
});

export const addHotUserSuccess = payload => ({
    type: ADD_HOTUSER_REQUEST_SUCCESS,
    payload
});

export const addHotUserFailure = payload => ({
    type: ADD_HOTUSER_REQUEST_FAILURE,
    payload
});

export const deleteHotUser = payload => ({
    type: DELETE_HOTUSER_REQUEST,
    payload
});

export const deleteHotUserSuccess = payload => ({
    type: DELETE_HOTUSER_REQUEST_SUCCESS,
    payload
});

export const deleteHotUserFailure = payload => ({
    type: DELETE_HOTUSER_REQUEST_FAILURE,
    payload
});

export const syncHotUser = payload => ({
    type: SYNC_HOTUSER_REQUEST,
    payload
});

export const syncHotUserSuccess = payload => ({
    type: SYNC_HOTUSER_REQUEST_SUCCESS,
    payload
});

export const syncHotUserFailure = payload => ({
    type: SYNC_HOTUSER_REQUEST_FAILURE,
    payload
});

export const getUserList = payload => ({
    type: GET_USER_LIST_REQUEST,
    payload
});

export const getUserListSuccess = payload => ({
    type: GET_USER_LIST_SUCCESS,
    payload
});

export const getUserListFailure = payload => ({
    type: GET_USER_LIST_FAILURE,
    payload
});

export const login = payload => ({
    type: LOGIN_REQUEST,
    payload
});

export const loginSuccess = payload => ({
    type: LOGIN_SUCCESS,
    payload
});

export const loginFailure = payload => ({
    type: LOGIN_FAILURE,
    payload
});

export const signup = payload => ({
    type: SIGNUP_REQUEST,
    payload
});

export const signupSuccess = payload => ({
    type: SIGNUP_SUCCESS,
    payload
});

export const signupFailure = payload => ({
    type: SIGNUP_FAILURE,
    payload
});

export const resend = payload => ({
    type: RESEND_REQUEST,
    payload
});

export const resendSuccess = payload => ({
    type: RESEND_SUCCESS,
    payload
});

export const resendFailure = payload => ({
    type: RESEND_FAILURE,
    payload
});

export const resetPassword = payload => ({
    type: RESET_PASSWORD_REQUEST,
    payload
});

export const resetPasswordSuccess = payload => ({
    type: RESET_PASSWORD_SUCCESS,
    payload
});

export const resetPasswordFailure = payload => ({
    type: RESET_PASSWORD_FAILURE,
    payload
});